import React from 'react'

const ArchivedJobs = () => {
  return (
    <div>ArchivedJobs</div>
  )
}

export default ArchivedJobs